import { useState } from 'react';

const VIDEO_URL = '/media/7ca7695e-da0e-4e75-9bc7-54d3fb53cf8d_WhatsApp-Video-2026-04-03-at-21.29.36-cb9da2d487.mp4';

export default function VideoSection() {
  const [playing, setPlaying] = useState(false);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Sol: Video */}
          <div className="relative rounded-2xl overflow-hidden bg-brand-navy aspect-video">
            <video
              src={VIDEO_URL}
              className="w-full h-full object-cover"
              controls={playing}
              playsInline
              preload="metadata"
              onPlay={() => setPlaying(true)}
              onPause={() => setPlaying(false)}
              onEnded={() => setPlaying(false)}
            />
            {!playing && (
              <button
                onClick={() => {
                  const vid = document.querySelector('video') as HTMLVideoElement;
                  if (vid) { vid.play(); setPlaying(true); }
                }}
                className="absolute inset-0 flex flex-col items-center justify-center bg-black/40 hover:bg-black/30 transition-all duration-300 cursor-pointer group"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-brand-orange rounded-full group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-play-fill text-white text-2xl ml-1"></i>
                </div>
                <p className="text-white text-sm font-medium mt-4 opacity-80">Müşteri Videosunu İzle</p>
              </button>
            )}
            {/* Rozet */}
            <div className="absolute top-4 left-4 bg-brand-orange text-white text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5">
              <i className="ri-video-line text-sm"></i>
              Müşteri Yorumu
            </div>
          </div>

          {/* Sağ: Açıklama */}
          <div>
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Gerçek Deneyimler</p>
            <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-6 leading-tight">
              Müşterilerimiz<br />Kendi Ağzından Anlatıyor
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Türkiye&apos;den Avrupa&apos;ya taşınan yüzlerce müşterimizden biri de bu videoyu bizimle paylaştı. Gerçek deneyimler, gerçek insanlar — hiçbir şey abartılmadan.
            </p>
            <div className="flex flex-col gap-4">
              {[
                { icon: 'ri-shield-check-line', text: 'Hasarsız ve zamanında teslimat' },
                { icon: 'ri-whatsapp-line', text: '7/24 WhatsApp ile anlık iletişim' },
                { icon: 'ri-map-pin-2-line', text: 'Kapıdan kapıya, 27 Avrupa ülkesi' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <span className="text-brand-navy text-sm font-medium">{item.text}</span>
                </div>
              ))}
            </div>
            <div className="mt-8 pt-8 border-t border-gray-100">
              <p className="text-gray-400 text-xs mb-1">Siz de deneyiminizi paylaşmak ister misiniz?</p>
              <a
                href="https://wa.me/905322376576?text=Merhaba%2C%20deneyimimi%20paylaşmak%20istiyorum."
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white px-5 py-2.5 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-line text-base"></i></span>
                WhatsApp&apos;tan Yaz
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
